// @/locales/en-US.ts
export default {
  pamm: {
    header: 'PAMM',
    searchPlaceholder: 'Search by PAMM name or manager name',
    tab: {
      highReturn: 'High Return',
      lowDrawdown: 'Low Drawdown',
      lowPerformanceFee: 'Low Performance Fee',
      lowManagementFee: 'Low Management Fee',
      all: 'All',
    },
    list: {
      return: 'Return Rate',
      maxDrawdown: 'Max Drawdown',
      managementFee: 'ManagementFee/Year',
      performanceFee: 'Performance Fee',
    },
    action: 'Subscribe',
    expand: 'Expand {total} PAMMs',
    collapse: 'Collapse',
    card: {
      join: 'Subscribe',
    },
    detail: {
      backToList: 'Back to PAMM Market',
      tabs: {
        overview: 'Overview',
        order: 'Orders',
      },
      share: {
        downloadImage: 'Download Image',
        copyLink: 'Copy Link',
        sendEmail: 'Send Email',
        facebook: 'Facebook',
        twitter: 'Twitter',
        dataPeriod: 'Data Period',
        showMetrics: 'Show Metrics',
        totalProfit: 'Total Profit',
        maxDrawdown: 'Max Drawdown',
        riskLevel: 'Risk Level',
        equity: 'Equity',
        inviteCode: 'Invite Code',
      },
      subscription: {
        securityReminder: 'Security Reminder',
        completeInfo: 'Complete Profile',
        lpoa: 'LPOA',
        subscribe: 'Subscribe',
        setPassword: 'Set Password',
        completeProfile: 'Complete Now',
        agreeLpoa: 'I confirm that I have read and agree to the LPOA terms',
        download: 'Download',
        cancel: 'Cancel',
        agree: 'Agree'
      },
      header: {
        manager: 'Manager',
        description: 'Description'
      },
      overview: {
        introduction: 'Trading Introduction',
        summary: 'Summary',
        orderAnalysis: 'Order Analysis',
        tradeProfitLoss: 'Trading Profit/Loss',
        monthlyReturn: 'Monthly Return',
        tradeCurrency: 'Trading Statistics',
        profitAnalysis: 'Profit Analysis',
        netValue: 'Net Value',
        subscriptionCount: 'Subscribers',
        settlementCycle: 'Settlement Cycle',
        publishDate: 'Publish Date',
        profitTrades: 'Profit Trades/Count',
        lossTrades: 'Loss Trades',
        buyTrades: 'Buy Trades',
        sellTrades: 'Sell Trades',
        profitWeeks: 'Profitable Weeks',
        lossWeeks: 'Loss Weeks',
        tradeCount: 'Trade Count',
        avgWeeklyTrades: 'Avg. Weekly Trades',
        avgTradeTime: 'Avg. Trade Time (Hours)',
        profit: 'Profit',
        loss: 'Loss',
        profitLossRatio: 'Profit/Loss Ratio',
        totalProfitLoss: 'Total Profit/Loss',
        maxDailyProfit: 'Max Daily Profit',
        maxDailyLoss: 'Max Daily Loss',
        unit: 'Unit: Transactions'
      },
      order: {
        open: 'Open',
        close: 'Close',
        delayWarning: 'Orders under this tab are delayed by 4 hours',
        totalProfit: 'Total Profit',
        orderProfit: 'Order Profit',
        interest: 'Interest',
        commission: 'Commission',
        id: 'ID',
        volume: 'Volume',
        openPrice: 'Open Price',
        openTime: 'Open Time',
        closePrice: 'Close Price',
        closeTime: 'Close Time',
        takeProfit: 'Take Profit',
        stopLoss: 'Stop Loss',
        swaps: 'Swaps',
        trend: 'Trend',
        type: 'Type',
        buy: 'Buy',
        sell: 'Sell',
        profit: 'Profit'
      },
      shareSub: {
        yieldRate: 'Yield Rate',
        maxDrawdown: 'Max Drawdown',
        dataPeriod: '* Data Period',
        inviteCode: 'Invite Code',
        totalProfitUSD: 'Total Profit (USD)',
        equityUSD: 'Equity (USD)',
        share:'SHARE',
      }
    },
    cycle: {
      day: 'Daily Settlement',
      week: 'Weekly Settlement',
      month: 'Monthly Settlement',
      month_last_week: 'Monthly Settlement'
    }
  },
  common: {
    loading: 'Loading...',
    noData: 'No Data',
  },
}
